import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  ListItemText,
  Checkbox,
  Box,
  Chip,
  type SelectProps as MuiSelectProps,
} from '@mui/material';
import { type ControllerRenderProps } from 'react-hook-form';
import { ChevronDownLight } from '@/static';
import { type AvatarInfo } from '@/types';
import Avatar from '../Avatar';
import styles from './styles';

type SelectFieldProps = {
  field?: ControllerRenderProps<any, any>;
  options?: { label: any; value: any; user?: AvatarInfo }[];
  helperText?: string;
  placeholder?: string;
} & MuiSelectProps;

const SelectField = ({
  field,
  options,
  label,
  size = 'small',
  error,
  helperText,
  multiple,
  placeholder,
  ...props
}: SelectFieldProps) => {
  const isEmpty = (value: any) => {
    if (multiple) {
      return !value || value.length === 0;
    }
    return value === '' || value === null || value === undefined;
  };

  return (
    <FormControl fullWidth size={size} error={error}>
      <InputLabel shrink sx={styles.label}>
        {label}
      </InputLabel>

      <Select
        {...field}
        label={label}
        multiple={multiple}
        displayEmpty
        renderValue={(value: any) => {
          if (isEmpty(value)) {
            return (
              <Box sx={styles.placeholder}>{placeholder || 'Επιλογή'}</Box>
            );
          }

          if (multiple) {
            return (
              <Box sx={styles.valueContainer}>
                {value.map((val: any) => {
                  const selectedValue = options?.find(
                    (option) => option.value === val,
                  );
                  return <Chip key={val} label={selectedValue?.label} />;
                })}
              </Box>
            );
          }

          const selectedValue = options?.find(
            (option) => option.value === value,
          );
          return (
            <Box sx={styles.valueContainer}>
              {selectedValue?.user && <Avatar user={selectedValue.user} />}

              <ListItemText sx={styles.valueText}>
                {selectedValue?.label}
              </ListItemText>
            </Box>
          );
        }}
        {...props}
        IconComponent={ChevronDownLight}
        sx={styles.select}
      >
        {options?.map((option, index) => (
          <MenuItem key={index} value={option.value} sx={styles.valueContainer}>
            {multiple && (
              <Checkbox
                checked={field?.value?.includes(option.value) || false}
              />
            )}

            {option?.user && <Avatar user={option.user} />}
            <ListItemText sx={styles.valueText}>{option.label}</ListItemText>
          </MenuItem>
        ))}
      </Select>

      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default SelectField;
